import type { Infer } from "superstruct";
import { is, type } from "superstruct";
import { nonEmptyStringStruct } from "@/utils/type-guards/isNonEmptyStringGuard";

/* CLIENT STRUCT */

const googleIdTokenResponse = type({ id_token: nonEmptyStringStruct });

export type GoogleIdTokenResponse = Infer<typeof googleIdTokenResponse>;

export function isGoogleAuth2ClientIdTokenResponse(
  value: unknown,
): value is GoogleIdTokenResponse {
  return is(value, googleIdTokenResponse);
}

/* ENDPOINT STRUCT */

const googleRequestWithCode = type({
  code: nonEmptyStringStruct,
});

type GoogleRequestWithCode = Infer<typeof googleRequestWithCode>;

export function isGoogleRequestWithCode(
  value: unknown,
): value is GoogleRequestWithCode {
  return is(value, googleRequestWithCode);
}
